export enum sensitivityLevel {
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3,
}
